// extracted by mini-css-extract-plugin
module.exports = {"circle":"circle_bukwU","rectangle":"rectangle_vv7Ds","warning":"warning_vQT0V"};